<template>
	<div v-if="visible" class="x-back-top" @click.stop="scrollToTop">
		<img src="@/assets/img/backTop.png" alt="" />
	</div>
</template>

<script setup lang="ts">
import { useScrollTop } from '@/hooks/remeberScroll'

const visible = ref(false)

const scrollToTop = () => {
	useScrollTop()
	// const requestAnimationFrame =
	// 	window.requestAnimationFrame ||
	// 	window.webkitRequestAnimationFrame ||
	// 	window.mozRequestAnimationFrame
	//
	// const scrollY = window.scrollY
	// const scrollStep = Math.PI / (45 * 2)
	// let currentScroll = 0
	//
	// function scroll() {
	// 	currentScroll += scrollStep
	// 	if (currentScroll >= Math.PI / 2) {
	// 		window.scrollTo(0, 0)
	// 	} else {
	// 		window.scrollTo(0, Math.sin(currentScroll) * scrollY)
	// 		requestAnimationFrame(scroll)
	// 	}
	// }
	//
	// scroll()
}

onMounted(() => {
	window.addEventListener('scroll', () => {
		visible.value = document.documentElement.scrollTop >= 300
	})
})
onUnmounted(() => {
	window.removeEventListener('scroll', () => {
		console.log('remove scroll')
		visible.value = false
	})
})
</script>

<style scoped lang="scss">
.x-back-top {
	position: fixed;
	bottom: 80px;
	right: 20px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	line-height: 1;
	align-items: center;
	justify-content: center;
	background: #fff;
	box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
	img {
		width: 24px;
		height: 24px;
	}
}
</style>
